import { renderSlot as _renderSlot, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-4ab77e94"), n = n(), _popScopeId(), n);
const _hoisted_1 = ["innerHTML"];
const _hoisted_2 = ["innerHTML"];
const _hoisted_3 = {
  key: 0
};
const _hoisted_4 = {
  key: 0
};
const _hoisted_5 = {
  key: 0
};
const _hoisted_6 = {
  key: 0
};
const _hoisted_7 = {
  key: 0
};
const _hoisted_8 = {
  key: 0
};
const _hoisted_9 = {
  key: 0
};
const _hoisted_10 = {
  key: 0
};
const _hoisted_11 = {
  key: 0
};
const _hoisted_12 = {
  key: 0
};
const _hoisted_13 = {
  key: 0
};
const _hoisted_14 = {
  key: 0
};
const _hoisted_15 = {
  key: 0
};
const _hoisted_16 = {
  key: 0
};
const _hoisted_17 = {
  key: 0
};
const _hoisted_18 = {
  key: 0
};
const _hoisted_19 = {
  key: 0
};
const _hoisted_20 = {
  key: 0
};
const _hoisted_21 = {
  key: 0
};
const _hoisted_22 = {
  key: 0
};
const _hoisted_23 = {
  key: 0
};
const _hoisted_24 = {
  key: 0
};
const _hoisted_25 = {
  key: 0
};
const _hoisted_26 = {
  key: 0
};
const _hoisted_27 = {
  key: 0
};
const _hoisted_28 = {
  key: 0
};
const _hoisted_29 = {
  class: "average-row"
};
const _hoisted_30 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("td", {
  class: "title"
}, "AVERAGE", -1));
const _hoisted_31 = {
  class: "new-customer"
};
const _hoisted_32 = {
  key: 1
};
const _hoisted_33 = {
  class: "first-order"
};
const _hoisted_34 = {
  class: "offset"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_b_th = _resolveComponent("b-th");
  const _component_hug_value = _resolveComponent("hug-value");
  const _component_b_tr = _resolveComponent("b-tr");
  const _component_wrap_with_popover = _resolveComponent("wrap-with-popover");
  const _component_flex_row = _resolveComponent("flex-row");
  const _component_AppIcon = _resolveComponent("AppIcon");
  const _component_date_value = _resolveComponent("date-value");
  const _component_value_element = _resolveComponent("value-element");
  const _component_percentage_value = _resolveComponent("percentage-value");
  const _component_evolution_value = _resolveComponent("evolution-value");
  const _component_slot_with_evolution_value = _resolveComponent("slot-with-evolution-value");
  const _component_currency_value = _resolveComponent("currency-value");
  const _component_number_value = _resolveComponent("number-value");
  const _component_boxed_value = _resolveComponent("boxed-value");
  const _component_b_table_lite = _resolveComponent("b-table-lite");
  const _component_wrap_table_with_show_more = _resolveComponent("wrap-table-with-show-more");
  const _component_table_with_title = _resolveComponent("table-with-title");
  const _component_b_table = _resolveComponent("b-table");
  return _openBlock(), _createElementBlock(_Fragment, null, [_createVNode(_component_table_with_title, {
    title: "LTV",
    class: "ltv-period-table",
    noDownload: "",
    onGoogleSheetDownload: _ctx.downloadPerformanceGoogleSheet,
    onCopy: _ctx.copyPerformancePeriodCSV,
    fields: $options.fields,
    loading: $props.loading
  }, {
    "period-selector": _withCtx(() => [_renderSlot(_ctx.$slots, "period-selector", {}, undefined, true)]),
    default: _withCtx(() => [_createVNode(_component_wrap_table_with_show_more, {
      modelValue: $options.period_pager,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => $options.period_pager = $event),
      period: _ctx.period
    }, {
      default: _withCtx(() => [_createVNode(_component_b_table_lite, {
        class: "lite-table lite-table-hoverable period-table ltv-table",
        fields: $options.fields,
        bordered: "",
        responsive: "",
        fixed: "",
        items: $options.items,
        "sticky-header": true,
        tbodyTrClass: item => _ctx.handleRowClass(item, $options.items),
        "no-border-collapse": "",
        onRowClicked: _ctx.handleRowClick
      }, {
        "thead-top": _withCtx(() => [_createVNode(_component_b_tr, {
          class: "headers"
        }, {
          default: _withCtx(() => [_createVNode(_component_b_th, {
            colspan: "1",
            style: {
              borderRight: 'none'
            }
          }), _createVNode(_component_b_th, {
            colspan: "1",
            "sticky-column": "",
            style: {
              borderRight: 'none'
            }
          }), _createVNode(_component_b_th, {
            colspan: "2"
          }), _createVNode(_component_b_th, {
            colspan: $options.fields.length - 4,
            class: "ltv",
            style: {
              color: '#E94E1B',
              backgroundColor: '#FFF2E8'
            }
          }, {
            default: _withCtx(() => [_createVNode(_component_hug_value, null, {
              default: _withCtx(() => [_createTextVNode("Months since first order")]),
              _: 1
            })]),
            _: 1
          }, 8, ["colspan"])]),
          _: 1
        })]),
        "head()": _withCtx(col => [_createVNode(_component_flex_row, {
          id: `ltv-period-table-${col?.column}`,
          styles: {
            justifyContent: col.field.justify,
            ...col.field.thStyle,
            'line-height': '130%'
          }
        }, {
          default: _withCtx(() => [_createVNode(_component_wrap_with_popover, {
            target: `ltv-period-table-${col?.column}`
          }, {
            title: _withCtx(() => [_createElementVNode("div", {
              innerHTML: $options.getDescriptionBasedOnKpiKey(col?.column).title
            }, null, 8, _hoisted_1)]),
            content: _withCtx(() => [_createTextVNode(_toDisplayString($options.getDescriptionBasedOnKpiKey(col?.column).detail), 1)]),
            default: _withCtx(() => [_createElementVNode("div", {
              innerHTML: col?.column === 'period_agg' ? $options.getPeriodColumnTitle : col?.label,
              class: "title"
            }, null, 8, _hoisted_2)]),
            _: 2
          }, 1032, ["target"])]),
          _: 2
        }, 1032, ["id", "styles"])]),
        "cell(selector)": _withCtx(row => [_createVNode(_component_hug_value, {
          loading: $props.loading
        }, {
          default: _withCtx(() => [_createVNode(_component_AppIcon, {
            icon: `zoom-${row.item.selected ? 'out' : 'in'}`,
            color: row.item.selected ? null : '#ADADAD',
            size: 16
          }, null, 8, ["icon", "color"])]),
          _: 2
        }, 1032, ["loading"])]),
        "cell(cohort_period)": _withCtx(row => [_createVNode(_component_date_value, {
          value: row.item?.cohort_period,
          format: $options.getDateValueFormat,
          styles: {
            justifyContent: 'flex-start',
            ..._ctx.activateDateValueStyles(row)
          },
          loading: $props.loading
        }, null, 8, ["value", "format", "styles", "loading"])]),
        "cell(ltv_new_customers)": _withCtx(row => [_createVNode(_component_hug_value, {
          loading: $props.loading,
          style: {
            "padding": "0px 8px"
          }
        }, {
          default: _withCtx(() => [_createVNode(_component_slot_with_evolution_value, null, {
            evolution: _withCtx(() => [_createVNode(_component_evolution_value, {
              value: row.item?.[$data.evolCategory[_ctx.periodCategory]] * 100
            }, {
              default: _withCtx(({
                color
              }) => [_createVNode(_component_percentage_value, {
                value: row.item?.[$data.evolCategory[_ctx.periodCategory]],
                color: color,
                charCount: 10,
                precision: Math.abs(row.item?.[$data.evolCategory[_ctx.periodCategory]]) >= 0.001 && Math.abs(row.item?.[$data.evolCategory[_ctx.periodCategory]]) <= 0.009 ? 1 : 0,
                showSign: ""
              }, null, 8, ["value", "color", "precision"])]),
              _: 2
            }, 1032, ["value"])]),
            default: _withCtx(() => [_createVNode(_component_value_element, {
              value: $options.customerNumberFormat(row.item?.customers_in_cohort)
            }, null, 8, ["value"])]),
            _: 2
          }, 1024)]),
          _: 2
        }, 1032, ["loading"])]),
        "cell(ltv_first_order)": _withCtx(row => [!row.item?.kpis?.[_ctx.ltv]?.m00 ? (_openBlock(), _createElementBlock("div", _hoisted_3)) : (_openBlock(), _createBlock(_component_hug_value, {
          key: 1,
          loading: $props.loading,
          style: {
            "padding": "0px 8px 0px 0px"
          }
        }, {
          default: _withCtx(() => [$data.currency_ltv_options.includes(_ctx.ltv) ? (_openBlock(), _createBlock(_component_currency_value, {
            key: 0,
            value: $options.customerNumberFormat(row.item?.kpis?.[_ctx.ltv]?.m00),
            allowPrecisionModification: false,
            charCount: 5,
            precision: "1"
          }, null, 8, ["value"])) : _createCommentVNode("", true), $data.percentage_ltv_options.includes(_ctx.ltv) ? (_openBlock(), _createBlock(_component_percentage_value, {
            key: 1,
            value: $options.customerNumberFormat(row.item?.kpis?.[_ctx.ltv]?.m00),
            allowPrecisionModification: false,
            charCount: 5,
            precision: "1"
          }, null, 8, ["value"])) : _createCommentVNode("", true), $data.number_ltv_options.includes(_ctx.ltv) ? (_openBlock(), _createBlock(_component_number_value, {
            key: 2,
            value: $options.customerNumberFormat(row.item?.kpis?.[_ctx.ltv]?.m00),
            allowPrecisionModification: false,
            charCount: 5,
            precision: "1",
            tight: ""
          }, null, 8, ["value"])) : _createCommentVNode("", true)]),
          _: 2
        }, 1032, ["loading"]))]),
        "cell(ltv_offset_00)": _withCtx(row => [!row.item?.kpis?.[_ctx.ltv]?.m00 ? (_openBlock(), _createElementBlock("div", _hoisted_4)) : (_openBlock(), _createBlock(_component_boxed_value, {
          key: 1,
          bgColor: $options.getColorForDecile(row.item?.kpis?.[_ctx.ltv]?.m00, $options.computedMinMax.min, $options.computedMinMax.max, $data.CUSTOMER_INSIGHTS_LTV_COLORS, 5, 4),
          loading: $props.loading
        }, {
          default: _withCtx(() => [_createVNode(_component_hug_value, {
            loading: $props.loading,
            style: {
              "padding": "0px 8px 0px 0px"
            }
          }, {
            default: _withCtx(() => [$data.currency_ltv_options.includes(_ctx.ltv) ? (_openBlock(), _createBlock(_component_currency_value, {
              key: 0,
              value: $options.customerNumberFormat(row.item?.kpis?.[_ctx.ltv]?.m00),
              allowPrecisionModification: false,
              charCount: 5,
              precision: "1"
            }, null, 8, ["value"])) : _createCommentVNode("", true), $data.percentage_ltv_options.includes(_ctx.ltv) ? (_openBlock(), _createBlock(_component_percentage_value, {
              key: 1,
              value: $options.customerNumberFormat(row.item?.kpis?.[_ctx.ltv]?.m00),
              allowPrecisionModification: false,
              charCount: 5,
              precision: "1"
            }, null, 8, ["value"])) : _createCommentVNode("", true), $data.number_ltv_options.includes(_ctx.ltv) ? (_openBlock(), _createBlock(_component_number_value, {
              key: 2,
              value: $options.customerNumberFormat(row.item?.kpis?.[_ctx.ltv]?.m00),
              allowPrecisionModification: false,
              charCount: 5,
              precision: "1",
              tight: ""
            }, null, 8, ["value"])) : _createCommentVNode("", true)]),
            _: 2
          }, 1032, ["loading"])]),
          _: 2
        }, 1032, ["bgColor", "loading"]))]),
        "cell(ltv_offset_01)": _withCtx(row => [!row.item?.kpis?.[_ctx.ltv]?.m01 ? (_openBlock(), _createElementBlock("div", _hoisted_5)) : (_openBlock(), _createBlock(_component_boxed_value, {
          key: 1,
          bgColor: $options.getColorForDecile(row.item?.kpis?.[_ctx.ltv]?.m01, $options.computedMinMax.min, $options.computedMinMax.max, $data.CUSTOMER_INSIGHTS_LTV_COLORS, 5, 4),
          loading: $props.loading
        }, {
          default: _withCtx(() => [_createVNode(_component_hug_value, {
            loading: $props.loading,
            style: {
              "padding": "0px 8px 0px 0px"
            }
          }, {
            default: _withCtx(() => [$data.currency_ltv_options.includes(_ctx.ltv) ? (_openBlock(), _createBlock(_component_currency_value, {
              key: 0,
              value: $options.customerNumberFormat(row.item?.kpis?.[`ltv_revenue_excl_vat`].m01),
              allowPrecisionModification: false,
              charCount: 5,
              precision: "1"
            }, null, 8, ["value"])) : _createCommentVNode("", true), $data.percentage_ltv_options.includes(_ctx.ltv) ? (_openBlock(), _createBlock(_component_percentage_value, {
              key: 1,
              value: $options.customerNumberFormat(row.item?.kpis?.[_ctx.ltv]?.m01),
              allowPrecisionModification: false,
              charCount: 5,
              precision: "1"
            }, null, 8, ["value"])) : _createCommentVNode("", true), $data.number_ltv_options.includes(_ctx.ltv) ? (_openBlock(), _createBlock(_component_number_value, {
              key: 2,
              value: $options.customerNumberFormat(row.item?.kpis?.[_ctx.ltv]?.m01),
              allowPrecisionModification: false,
              charCount: 5,
              precision: "1",
              tight: ""
            }, null, 8, ["value"])) : _createCommentVNode("", true)]),
            _: 2
          }, 1032, ["loading"])]),
          _: 2
        }, 1032, ["bgColor", "loading"]))]),
        "cell(ltv_offset_02)": _withCtx(row => [!row.item?.kpis?.[_ctx.ltv]?.m02 ? (_openBlock(), _createElementBlock("div", _hoisted_6)) : (_openBlock(), _createBlock(_component_boxed_value, {
          key: 1,
          bgColor: $options.getColorForDecile(row.item?.kpis?.[_ctx.ltv]?.m02, $options.computedMinMax.min, $options.computedMinMax.max, $data.CUSTOMER_INSIGHTS_LTV_COLORS, 5, 4),
          loading: $props.loading
        }, {
          default: _withCtx(() => [_createVNode(_component_hug_value, {
            loading: $props.loading,
            style: {
              "padding": "0px 8px 0px 0px"
            }
          }, {
            default: _withCtx(() => [$data.currency_ltv_options.includes(_ctx.ltv) ? (_openBlock(), _createBlock(_component_currency_value, {
              key: 0,
              value: $options.customerNumberFormat(row.item?.kpis?.[_ctx.ltv]?.m02),
              allowPrecisionModification: false,
              charCount: 5,
              precision: "1"
            }, null, 8, ["value"])) : _createCommentVNode("", true), $data.percentage_ltv_options.includes(_ctx.ltv) ? (_openBlock(), _createBlock(_component_percentage_value, {
              key: 1,
              value: $options.customerNumberFormat(row.item?.kpis?.[_ctx.ltv]?.m02),
              allowPrecisionModification: false,
              charCount: 5,
              precision: "1"
            }, null, 8, ["value"])) : _createCommentVNode("", true), $data.number_ltv_options.includes(_ctx.ltv) ? (_openBlock(), _createBlock(_component_number_value, {
              key: 2,
              value: $options.customerNumberFormat(row.item?.kpis?.[_ctx.ltv]?.m02),
              allowPrecisionModification: false,
              charCount: 5,
              precision: "1",
              tight: ""
            }, null, 8, ["value"])) : _createCommentVNode("", true)]),
            _: 2
          }, 1032, ["loading"])]),
          _: 2
        }, 1032, ["bgColor", "loading"]))]),
        "cell(ltv_offset_03)": _withCtx(row => [!row.item?.kpis?.[_ctx.ltv]?.m03 ? (_openBlock(), _createElementBlock("div", _hoisted_7)) : (_openBlock(), _createBlock(_component_boxed_value, {
          key: 1,
          bgColor: $options.getColorForDecile(row.item?.kpis?.[_ctx.ltv]?.m03, $options.computedMinMax.min, $options.computedMinMax.max, $data.CUSTOMER_INSIGHTS_LTV_COLORS, 5, 4),
          loading: $props.loading
        }, {
          default: _withCtx(() => [_createVNode(_component_hug_value, {
            loading: $props.loading,
            style: {
              "padding": "0px 8px 0px 0px"
            }
          }, {
            default: _withCtx(() => [$data.currency_ltv_options.includes(_ctx.ltv) ? (_openBlock(), _createBlock(_component_currency_value, {
              key: 0,
              value: $options.customerNumberFormat(row.item?.kpis?.[_ctx.ltv]?.m03),
              allowPrecisionModification: false,
              charCount: 5,
              precision: "1"
            }, null, 8, ["value"])) : _createCommentVNode("", true), $data.percentage_ltv_options.includes(_ctx.ltv) ? (_openBlock(), _createBlock(_component_percentage_value, {
              key: 1,
              value: $options.customerNumberFormat(row.item?.kpis?.[_ctx.ltv]?.m03),
              allowPrecisionModification: false,
              charCount: 5,
              precision: "1"
            }, null, 8, ["value"])) : _createCommentVNode("", true), $data.number_ltv_options.includes(_ctx.ltv) ? (_openBlock(), _createBlock(_component_number_value, {
              key: 2,
              value: $options.customerNumberFormat(row.item?.kpis?.[_ctx.ltv]?.m03),
              allowPrecisionModification: false,
              charCount: 5,
              precision: "1",
              tight: ""
            }, null, 8, ["value"])) : _createCommentVNode("", true)]),
            _: 2
          }, 1032, ["loading"])]),
          _: 2
        }, 1032, ["bgColor", "loading"]))]),
        "cell(ltv_offset_04)": _withCtx(row => [!row.item?.kpis?.[_ctx.ltv]?.m04 ? (_openBlock(), _createElementBlock("div", _hoisted_8)) : (_openBlock(), _createBlock(_component_boxed_value, {
          key: 1,
          bgColor: $options.getColorForDecile(row.item?.kpis?.[_ctx.ltv]?.m04, $options.computedMinMax.min, $options.computedMinMax.max, $data.CUSTOMER_INSIGHTS_LTV_COLORS, 5, 4),
          loading: $props.loading
        }, {
          default: _withCtx(() => [_createVNode(_component_hug_value, {
            loading: $props.loading,
            style: {
              "padding": "0px 8px 0px 0px"
            }
          }, {
            default: _withCtx(() => [$data.currency_ltv_options.includes(_ctx.ltv) ? (_openBlock(), _createBlock(_component_currency_value, {
              key: 0,
              value: $options.customerNumberFormat(row.item?.kpis?.[_ctx.ltv]?.m04),
              allowPrecisionModification: false,
              charCount: 5,
              precision: "1"
            }, null, 8, ["value"])) : _createCommentVNode("", true), $data.percentage_ltv_options.includes(_ctx.ltv) ? (_openBlock(), _createBlock(_component_percentage_value, {
              key: 1,
              value: $options.customerNumberFormat(row.item?.kpis?.[_ctx.ltv]?.m04),
              allowPrecisionModification: false,
              charCount: 5,
              precision: "1"
            }, null, 8, ["value"])) : _createCommentVNode("", true), $data.number_ltv_options.includes(_ctx.ltv) ? (_openBlock(), _createBlock(_component_number_value, {
              key: 2,
              value: $options.customerNumberFormat(row.item?.kpis?.[_ctx.ltv]?.m04),
              allowPrecisionModification: false,
              charCount: 5,
              precision: "1",
              tight: ""
            }, null, 8, ["value"])) : _createCommentVNode("", true)]),
            _: 2
          }, 1032, ["loading"])]),
          _: 2
        }, 1032, ["bgColor", "loading"]))]),
        "cell(ltv_offset_05)": _withCtx(row => [!row.item?.kpis?.[_ctx.ltv]?.m05 ? (_openBlock(), _createElementBlock("div", _hoisted_9)) : (_openBlock(), _createBlock(_component_boxed_value, {
          key: 1,
          bgColor: $options.getColorForDecile(row.item?.kpis?.[_ctx.ltv]?.m05, $options.computedMinMax.min, $options.computedMinMax.max, $data.CUSTOMER_INSIGHTS_LTV_COLORS, 5, 4),
          loading: $props.loading
        }, {
          default: _withCtx(() => [_createVNode(_component_hug_value, {
            loading: $props.loading,
            style: {
              "padding": "0px 8px 0px 0px"
            }
          }, {
            default: _withCtx(() => [$data.currency_ltv_options.includes(_ctx.ltv) ? (_openBlock(), _createBlock(_component_currency_value, {
              key: 0,
              value: $options.customerNumberFormat(row.item?.kpis?.[_ctx.ltv]?.m05),
              allowPrecisionModification: false,
              charCount: 5,
              precision: "1"
            }, null, 8, ["value"])) : _createCommentVNode("", true), $data.percentage_ltv_options.includes(_ctx.ltv) ? (_openBlock(), _createBlock(_component_percentage_value, {
              key: 1,
              value: $options.customerNumberFormat(row.item?.kpis?.[_ctx.ltv]?.m05),
              allowPrecisionModification: false,
              charCount: 5,
              precision: "1"
            }, null, 8, ["value"])) : _createCommentVNode("", true), $data.number_ltv_options.includes(_ctx.ltv) ? (_openBlock(), _createBlock(_component_number_value, {
              key: 2,
              value: $options.customerNumberFormat(row.item?.kpis?.[_ctx.ltv]?.m05),
              allowPrecisionModification: false,
              charCount: 5,
              precision: "1",
              tight: ""
            }, null, 8, ["value"])) : _createCommentVNode("", true)]),
            _: 2
          }, 1032, ["loading"])]),
          _: 2
        }, 1032, ["bgColor", "loading"]))]),
        "cell(ltv_offset_06)": _withCtx(row => [!row.item?.kpis?.[_ctx.ltv]?.m06 ? (_openBlock(), _createElementBlock("div", _hoisted_10)) : (_openBlock(), _createBlock(_component_boxed_value, {
          key: 1,
          bgColor: $options.getColorForDecile(row.item?.kpis?.[_ctx.ltv]?.m06, $options.computedMinMax.min, $options.computedMinMax.max, $data.CUSTOMER_INSIGHTS_LTV_COLORS, 5, 4),
          loading: $props.loading
        }, {
          default: _withCtx(() => [_createVNode(_component_hug_value, {
            loading: $props.loading,
            style: {
              "padding": "0px 8px 0px 0px"
            }
          }, {
            default: _withCtx(() => [$data.currency_ltv_options.includes(_ctx.ltv) ? (_openBlock(), _createBlock(_component_currency_value, {
              key: 0,
              value: $options.customerNumberFormat(row.item?.kpis?.[_ctx.ltv]?.m06),
              allowPrecisionModification: false,
              charCount: 5,
              precision: "1"
            }, null, 8, ["value"])) : _createCommentVNode("", true), $data.percentage_ltv_options.includes(_ctx.ltv) ? (_openBlock(), _createBlock(_component_percentage_value, {
              key: 1,
              value: $options.customerNumberFormat(row.item?.kpis?.[_ctx.ltv]?.m06),
              allowPrecisionModification: false,
              charCount: 5,
              precision: "1"
            }, null, 8, ["value"])) : _createCommentVNode("", true), $data.number_ltv_options.includes(_ctx.ltv) ? (_openBlock(), _createBlock(_component_number_value, {
              key: 2,
              value: $options.customerNumberFormat(row.item?.kpis?.[_ctx.ltv]?.m06),
              allowPrecisionModification: false,
              charCount: 5,
              precision: "1",
              tight: ""
            }, null, 8, ["value"])) : _createCommentVNode("", true)]),
            _: 2
          }, 1032, ["loading"])]),
          _: 2
        }, 1032, ["bgColor", "loading"]))]),
        "cell(ltv_offset_07)": _withCtx(row => [!row.item?.kpis?.[_ctx.ltv]?.m07 ? (_openBlock(), _createElementBlock("div", _hoisted_11)) : (_openBlock(), _createBlock(_component_boxed_value, {
          key: 1,
          bgColor: $options.getColorForDecile(row.item?.kpis?.[_ctx.ltv]?.m07, $options.computedMinMax.min, $options.computedMinMax.max, $data.CUSTOMER_INSIGHTS_LTV_COLORS, 5, 4),
          loading: $props.loading
        }, {
          default: _withCtx(() => [_createVNode(_component_hug_value, {
            loading: $props.loading,
            style: {
              "padding": "0px 8px 0px 0px"
            }
          }, {
            default: _withCtx(() => [$data.currency_ltv_options.includes(_ctx.ltv) ? (_openBlock(), _createBlock(_component_currency_value, {
              key: 0,
              value: $options.customerNumberFormat(row.item?.kpis?.[_ctx.ltv]?.m07),
              allowPrecisionModification: false,
              charCount: 5,
              precision: "1"
            }, null, 8, ["value"])) : _createCommentVNode("", true), $data.percentage_ltv_options.includes(_ctx.ltv) ? (_openBlock(), _createBlock(_component_percentage_value, {
              key: 1,
              value: $options.customerNumberFormat(row.item?.kpis?.[_ctx.ltv]?.m07),
              allowPrecisionModification: false,
              charCount: 5,
              precision: "1"
            }, null, 8, ["value"])) : _createCommentVNode("", true), $data.number_ltv_options.includes(_ctx.ltv) ? (_openBlock(), _createBlock(_component_number_value, {
              key: 2,
              value: $options.customerNumberFormat(row.item?.kpis?.[_ctx.ltv]?.m07),
              allowPrecisionModification: false,
              charCount: 5,
              precision: "1",
              tight: ""
            }, null, 8, ["value"])) : _createCommentVNode("", true)]),
            _: 2
          }, 1032, ["loading"])]),
          _: 2
        }, 1032, ["bgColor", "loading"]))]),
        "cell(ltv_offset_08)": _withCtx(row => [!row.item?.kpis?.[_ctx.ltv]?.m08 ? (_openBlock(), _createElementBlock("div", _hoisted_12)) : (_openBlock(), _createBlock(_component_boxed_value, {
          key: 1,
          bgColor: $options.getColorForDecile(row.item?.kpis?.[_ctx.ltv]?.m08, $options.computedMinMax.min, $options.computedMinMax.max, $data.CUSTOMER_INSIGHTS_LTV_COLORS, 5, 4),
          loading: $props.loading
        }, {
          default: _withCtx(() => [_createVNode(_component_hug_value, {
            loading: $props.loading,
            style: {
              "padding": "0px 8px 0px 0px"
            }
          }, {
            default: _withCtx(() => [$data.currency_ltv_options.includes(_ctx.ltv) ? (_openBlock(), _createBlock(_component_currency_value, {
              key: 0,
              value: $options.customerNumberFormat(row.item?.kpis?.[_ctx.ltv]?.m08),
              allowPrecisionModification: false,
              charCount: 5,
              precision: "1"
            }, null, 8, ["value"])) : _createCommentVNode("", true), $data.percentage_ltv_options.includes(_ctx.ltv) ? (_openBlock(), _createBlock(_component_percentage_value, {
              key: 1,
              value: $options.customerNumberFormat(row.item?.kpis?.[_ctx.ltv]?.m08),
              allowPrecisionModification: false,
              charCount: 5,
              precision: "1"
            }, null, 8, ["value"])) : _createCommentVNode("", true), $data.number_ltv_options.includes(_ctx.ltv) ? (_openBlock(), _createBlock(_component_number_value, {
              key: 2,
              value: $options.customerNumberFormat(row.item?.kpis?.[_ctx.ltv]?.m08),
              allowPrecisionModification: false,
              charCount: 5,
              precision: "1",
              tight: ""
            }, null, 8, ["value"])) : _createCommentVNode("", true)]),
            _: 2
          }, 1032, ["loading"])]),
          _: 2
        }, 1032, ["bgColor", "loading"]))]),
        "cell(ltv_offset_09)": _withCtx(row => [!row.item?.kpis?.[_ctx.ltv]?.m09 ? (_openBlock(), _createElementBlock("div", _hoisted_13)) : (_openBlock(), _createBlock(_component_boxed_value, {
          key: 1,
          bgColor: $options.getColorForDecile(row.item?.kpis?.[_ctx.ltv]?.m09, $options.computedMinMax.min, $options.computedMinMax.max, $data.CUSTOMER_INSIGHTS_LTV_COLORS, 5, 4),
          loading: $props.loading
        }, {
          default: _withCtx(() => [_createVNode(_component_hug_value, {
            loading: $props.loading,
            style: {
              "padding": "0px 8px 0px 0px"
            }
          }, {
            default: _withCtx(() => [$data.currency_ltv_options.includes(_ctx.ltv) ? (_openBlock(), _createBlock(_component_currency_value, {
              key: 0,
              value: $options.customerNumberFormat(row.item?.kpis?.[_ctx.ltv]?.m09),
              allowPrecisionModification: false,
              charCount: 5,
              precision: "1"
            }, null, 8, ["value"])) : _createCommentVNode("", true), $data.percentage_ltv_options.includes(_ctx.ltv) ? (_openBlock(), _createBlock(_component_percentage_value, {
              key: 1,
              value: $options.customerNumberFormat(row.item?.kpis?.[_ctx.ltv]?.m09),
              allowPrecisionModification: false,
              charCount: 5,
              precision: "1"
            }, null, 8, ["value"])) : _createCommentVNode("", true), $data.number_ltv_options.includes(_ctx.ltv) ? (_openBlock(), _createBlock(_component_number_value, {
              key: 2,
              value: $options.customerNumberFormat(row.item?.kpis?.[_ctx.ltv]?.m09),
              allowPrecisionModification: false,
              charCount: 5,
              precision: "1",
              tight: ""
            }, null, 8, ["value"])) : _createCommentVNode("", true)]),
            _: 2
          }, 1032, ["loading"])]),
          _: 2
        }, 1032, ["bgColor", "loading"]))]),
        "cell(ltv_offset_10)": _withCtx(row => [!row.item?.kpis?.[_ctx.ltv]?.m10 ? (_openBlock(), _createElementBlock("div", _hoisted_14)) : (_openBlock(), _createBlock(_component_boxed_value, {
          key: 1,
          bgColor: $options.getColorForDecile(row.item?.kpis?.[_ctx.ltv]?.m10, $options.computedMinMax.min, $options.computedMinMax.max, $data.CUSTOMER_INSIGHTS_LTV_COLORS, 5, 4),
          loading: $props.loading
        }, {
          default: _withCtx(() => [_createVNode(_component_hug_value, {
            loading: $props.loading,
            style: {
              "padding": "0px 8px 0px 0px"
            }
          }, {
            default: _withCtx(() => [$data.currency_ltv_options.includes(_ctx.ltv) ? (_openBlock(), _createBlock(_component_currency_value, {
              key: 0,
              value: $options.customerNumberFormat(row.item?.kpis?.[_ctx.ltv]?.m10),
              allowPrecisionModification: false,
              charCount: 5,
              precision: "1"
            }, null, 8, ["value"])) : _createCommentVNode("", true), $data.percentage_ltv_options.includes(_ctx.ltv) ? (_openBlock(), _createBlock(_component_percentage_value, {
              key: 1,
              value: $options.customerNumberFormat(row.item?.kpis?.[_ctx.ltv]?.m10),
              allowPrecisionModification: false,
              charCount: 5,
              precision: "1"
            }, null, 8, ["value"])) : _createCommentVNode("", true), $data.number_ltv_options.includes(_ctx.ltv) ? (_openBlock(), _createBlock(_component_number_value, {
              key: 2,
              value: $options.customerNumberFormat(row.item?.kpis?.[_ctx.ltv]?.m10),
              allowPrecisionModification: false,
              charCount: 5,
              precision: "1",
              tight: ""
            }, null, 8, ["value"])) : _createCommentVNode("", true)]),
            _: 2
          }, 1032, ["loading"])]),
          _: 2
        }, 1032, ["bgColor", "loading"]))]),
        "cell(ltv_offset_11)": _withCtx(row => [!row.item?.kpis?.[_ctx.ltv]?.m11 ? (_openBlock(), _createElementBlock("div", _hoisted_15)) : (_openBlock(), _createBlock(_component_boxed_value, {
          key: 1,
          bgColor: $options.getColorForDecile(row.item?.kpis?.[_ctx.ltv]?.m11, $options.computedMinMax.min, $options.computedMinMax.max, $data.CUSTOMER_INSIGHTS_LTV_COLORS, 5, 4),
          loading: $props.loading
        }, {
          default: _withCtx(() => [_createVNode(_component_hug_value, {
            loading: $props.loading,
            style: {
              "padding": "0px 8px 0px 0px"
            }
          }, {
            default: _withCtx(() => [$data.currency_ltv_options.includes(_ctx.ltv) ? (_openBlock(), _createBlock(_component_currency_value, {
              key: 0,
              value: $options.customerNumberFormat(row.item?.kpis?.[_ctx.ltv]?.m11),
              allowPrecisionModification: false,
              charCount: 5,
              precision: "1"
            }, null, 8, ["value"])) : _createCommentVNode("", true), $data.percentage_ltv_options.includes(_ctx.ltv) ? (_openBlock(), _createBlock(_component_percentage_value, {
              key: 1,
              value: $options.customerNumberFormat(row.item?.kpis?.[_ctx.ltv]?.m11),
              allowPrecisionModification: false,
              charCount: 5,
              precision: "1"
            }, null, 8, ["value"])) : _createCommentVNode("", true), $data.number_ltv_options.includes(_ctx.ltv) ? (_openBlock(), _createBlock(_component_number_value, {
              key: 2,
              value: $options.customerNumberFormat(row.item?.kpis?.[_ctx.ltv]?.m11),
              allowPrecisionModification: false,
              charCount: 5,
              precision: "1",
              tight: ""
            }, null, 8, ["value"])) : _createCommentVNode("", true)]),
            _: 2
          }, 1032, ["loading"])]),
          _: 2
        }, 1032, ["bgColor", "loading"]))]),
        "cell(ltv_offset_12)": _withCtx(row => [!row.item?.kpis?.[_ctx.ltv]?.m12 ? (_openBlock(), _createElementBlock("div", _hoisted_16)) : (_openBlock(), _createBlock(_component_boxed_value, {
          key: 1,
          bgColor: $options.getColorForDecile(row.item?.kpis?.[_ctx.ltv]?.m12, $options.computedMinMax.min, $options.computedMinMax.max, $data.CUSTOMER_INSIGHTS_LTV_COLORS, 5, 4),
          loading: $props.loading
        }, {
          default: _withCtx(() => [_createVNode(_component_hug_value, {
            loading: $props.loading,
            style: {
              "padding": "0px 8px 0px 0px"
            }
          }, {
            default: _withCtx(() => [$data.currency_ltv_options.includes(_ctx.ltv) ? (_openBlock(), _createBlock(_component_currency_value, {
              key: 0,
              value: $options.customerNumberFormat(row.item?.kpis?.[_ctx.ltv]?.m12),
              allowPrecisionModification: false,
              charCount: 5,
              precision: "1"
            }, null, 8, ["value"])) : _createCommentVNode("", true), $data.percentage_ltv_options.includes(_ctx.ltv) ? (_openBlock(), _createBlock(_component_percentage_value, {
              key: 1,
              value: $options.customerNumberFormat(row.item?.kpis?.[_ctx.ltv]?.m12),
              allowPrecisionModification: false,
              charCount: 5,
              precision: "1"
            }, null, 8, ["value"])) : _createCommentVNode("", true), $data.number_ltv_options.includes(_ctx.ltv) ? (_openBlock(), _createBlock(_component_number_value, {
              key: 2,
              value: $options.customerNumberFormat(row.item?.kpis?.[_ctx.ltv]?.m12),
              allowPrecisionModification: false,
              charCount: 5,
              precision: "1",
              tight: ""
            }, null, 8, ["value"])) : _createCommentVNode("", true)]),
            _: 2
          }, 1032, ["loading"])]),
          _: 2
        }, 1032, ["bgColor", "loading"]))]),
        "cell(ltv_offset_13)": _withCtx(row => [!row.item?.kpis?.[_ctx.ltv]?.m13 ? (_openBlock(), _createElementBlock("div", _hoisted_17)) : (_openBlock(), _createBlock(_component_boxed_value, {
          key: 1,
          bgColor: $options.getColorForDecile(row.item?.kpis?.[_ctx.ltv]?.m13, $options.computedMinMax.min, $options.computedMinMax.max, $data.CUSTOMER_INSIGHTS_LTV_COLORS, 5, 4),
          loading: $props.loading
        }, {
          default: _withCtx(() => [_createVNode(_component_hug_value, {
            loading: $props.loading,
            style: {
              "padding": "0px 8px 0px 0px"
            }
          }, {
            default: _withCtx(() => [$data.currency_ltv_options.includes(_ctx.ltv) ? (_openBlock(), _createBlock(_component_currency_value, {
              key: 0,
              value: $options.customerNumberFormat(row.item?.kpis?.[_ctx.ltv]?.m13),
              allowPrecisionModification: false,
              charCount: 5,
              precision: "1"
            }, null, 8, ["value"])) : _createCommentVNode("", true), $data.percentage_ltv_options.includes(_ctx.ltv) ? (_openBlock(), _createBlock(_component_percentage_value, {
              key: 1,
              value: $options.customerNumberFormat(row.item?.kpis?.[_ctx.ltv]?.m13),
              allowPrecisionModification: false,
              charCount: 5,
              precision: "1"
            }, null, 8, ["value"])) : _createCommentVNode("", true), $data.number_ltv_options.includes(_ctx.ltv) ? (_openBlock(), _createBlock(_component_number_value, {
              key: 2,
              value: $options.customerNumberFormat(row.item?.kpis?.[_ctx.ltv]?.m13),
              allowPrecisionModification: false,
              charCount: 5,
              precision: "1",
              tight: ""
            }, null, 8, ["value"])) : _createCommentVNode("", true)]),
            _: 2
          }, 1032, ["loading"])]),
          _: 2
        }, 1032, ["bgColor", "loading"]))]),
        "cell(ltv_offset_14)": _withCtx(row => [!row.item?.kpis?.[_ctx.ltv]?.m14 ? (_openBlock(), _createElementBlock("div", _hoisted_18)) : (_openBlock(), _createBlock(_component_boxed_value, {
          key: 1,
          bgColor: $options.getColorForDecile(row.item?.kpis?.[_ctx.ltv]?.m14, $options.computedMinMax.min, $options.computedMinMax.max, $data.CUSTOMER_INSIGHTS_LTV_COLORS, 5, 4),
          loading: $props.loading
        }, {
          default: _withCtx(() => [_createVNode(_component_hug_value, {
            loading: $props.loading,
            style: {
              "padding": "0px 8px 0px 0px"
            }
          }, {
            default: _withCtx(() => [$data.currency_ltv_options.includes(_ctx.ltv) ? (_openBlock(), _createBlock(_component_currency_value, {
              key: 0,
              value: $options.customerNumberFormat(row.item?.kpis?.[_ctx.ltv]?.m14),
              allowPrecisionModification: false,
              charCount: 5,
              precision: "1"
            }, null, 8, ["value"])) : _createCommentVNode("", true), $data.percentage_ltv_options.includes(_ctx.ltv) ? (_openBlock(), _createBlock(_component_percentage_value, {
              key: 1,
              value: $options.customerNumberFormat(row.item?.kpis?.[_ctx.ltv]?.m14),
              allowPrecisionModification: false,
              charCount: 5,
              precision: "1"
            }, null, 8, ["value"])) : _createCommentVNode("", true), $data.number_ltv_options.includes(_ctx.ltv) ? (_openBlock(), _createBlock(_component_number_value, {
              key: 2,
              value: $options.customerNumberFormat(row.item?.kpis?.[_ctx.ltv]?.m14),
              allowPrecisionModification: false,
              charCount: 5,
              precision: "1",
              tight: ""
            }, null, 8, ["value"])) : _createCommentVNode("", true)]),
            _: 2
          }, 1032, ["loading"])]),
          _: 2
        }, 1032, ["bgColor", "loading"]))]),
        "cell(ltv_offset_15)": _withCtx(row => [!row.item?.kpis?.[_ctx.ltv]?.m15 ? (_openBlock(), _createElementBlock("div", _hoisted_19)) : (_openBlock(), _createBlock(_component_boxed_value, {
          key: 1,
          bgColor: $options.getColorForDecile(row.item?.kpis?.[_ctx.ltv]?.m15, $options.computedMinMax.min, $options.computedMinMax.max, $data.CUSTOMER_INSIGHTS_LTV_COLORS, 5, 4),
          loading: $props.loading
        }, {
          default: _withCtx(() => [_createVNode(_component_hug_value, {
            loading: $props.loading,
            style: {
              "padding": "0px 8px 0px 0px"
            }
          }, {
            default: _withCtx(() => [$data.currency_ltv_options.includes(_ctx.ltv) ? (_openBlock(), _createBlock(_component_currency_value, {
              key: 0,
              value: $options.customerNumberFormat(row.item?.kpis?.[_ctx.ltv]?.m15),
              allowPrecisionModification: false,
              charCount: 5,
              precision: "1"
            }, null, 8, ["value"])) : _createCommentVNode("", true), $data.percentage_ltv_options.includes(_ctx.ltv) ? (_openBlock(), _createBlock(_component_percentage_value, {
              key: 1,
              value: $options.customerNumberFormat(row.item?.kpis?.[_ctx.ltv]?.m15),
              allowPrecisionModification: false,
              charCount: 5,
              precision: "1"
            }, null, 8, ["value"])) : _createCommentVNode("", true), $data.number_ltv_options.includes(_ctx.ltv) ? (_openBlock(), _createBlock(_component_number_value, {
              key: 2,
              value: $options.customerNumberFormat(row.item?.kpis?.[_ctx.ltv]?.m15),
              allowPrecisionModification: false,
              charCount: 5,
              precision: "1",
              tight: ""
            }, null, 8, ["value"])) : _createCommentVNode("", true)]),
            _: 2
          }, 1032, ["loading"])]),
          _: 2
        }, 1032, ["bgColor", "loading"]))]),
        "cell(ltv_offset_16)": _withCtx(row => [!row.item?.kpis?.[_ctx.ltv]?.m16 ? (_openBlock(), _createElementBlock("div", _hoisted_20)) : (_openBlock(), _createBlock(_component_boxed_value, {
          key: 1,
          bgColor: $options.getColorForDecile(row.item?.kpis?.[_ctx.ltv]?.m16, $options.computedMinMax.min, $options.computedMinMax.max, $data.CUSTOMER_INSIGHTS_LTV_COLORS, 5, 4),
          loading: $props.loading
        }, {
          default: _withCtx(() => [_createVNode(_component_hug_value, {
            loading: $props.loading,
            style: {
              "padding": "0px 8px 0px 0px"
            }
          }, {
            default: _withCtx(() => [$data.currency_ltv_options.includes(_ctx.ltv) ? (_openBlock(), _createBlock(_component_currency_value, {
              key: 0,
              value: $options.customerNumberFormat(row.item?.kpis?.[_ctx.ltv]?.m16),
              allowPrecisionModification: false,
              charCount: 5,
              precision: "1"
            }, null, 8, ["value"])) : _createCommentVNode("", true), $data.percentage_ltv_options.includes(_ctx.ltv) ? (_openBlock(), _createBlock(_component_percentage_value, {
              key: 1,
              value: $options.customerNumberFormat(row.item?.kpis?.[_ctx.ltv]?.m16),
              allowPrecisionModification: false,
              charCount: 5,
              precision: "1"
            }, null, 8, ["value"])) : _createCommentVNode("", true), $data.number_ltv_options.includes(_ctx.ltv) ? (_openBlock(), _createBlock(_component_number_value, {
              key: 2,
              value: $options.customerNumberFormat(row.item?.kpis?.[_ctx.ltv]?.m16),
              allowPrecisionModification: false,
              charCount: 5,
              precision: "1",
              tight: ""
            }, null, 8, ["value"])) : _createCommentVNode("", true)]),
            _: 2
          }, 1032, ["loading"])]),
          _: 2
        }, 1032, ["bgColor", "loading"]))]),
        "cell(ltv_offset_17)": _withCtx(row => [!row.item?.kpis?.[_ctx.ltv]?.m17 ? (_openBlock(), _createElementBlock("div", _hoisted_21)) : (_openBlock(), _createBlock(_component_boxed_value, {
          key: 1,
          bgColor: $options.getColorForDecile(row.item?.kpis?.[_ctx.ltv]?.m17, $options.computedMinMax.min, $options.computedMinMax.max, $data.CUSTOMER_INSIGHTS_LTV_COLORS, 5, 4),
          loading: $props.loading
        }, {
          default: _withCtx(() => [_createVNode(_component_hug_value, {
            loading: $props.loading,
            style: {
              "padding": "0px 8px 0px 0px"
            }
          }, {
            default: _withCtx(() => [$data.currency_ltv_options.includes(_ctx.ltv) ? (_openBlock(), _createBlock(_component_currency_value, {
              key: 0,
              value: $options.customerNumberFormat(row.item?.kpis?.[_ctx.ltv]?.m17),
              allowPrecisionModification: false,
              charCount: 5,
              precision: "1"
            }, null, 8, ["value"])) : _createCommentVNode("", true), $data.percentage_ltv_options.includes(_ctx.ltv) ? (_openBlock(), _createBlock(_component_percentage_value, {
              key: 1,
              value: $options.customerNumberFormat(row.item?.kpis?.[_ctx.ltv]?.m17),
              allowPrecisionModification: false,
              charCount: 5,
              precision: "1"
            }, null, 8, ["value"])) : _createCommentVNode("", true), $data.number_ltv_options.includes(_ctx.ltv) ? (_openBlock(), _createBlock(_component_number_value, {
              key: 2,
              value: $options.customerNumberFormat(row.item?.kpis?.[_ctx.ltv]?.m17),
              allowPrecisionModification: false,
              charCount: 5,
              precision: "1",
              tight: ""
            }, null, 8, ["value"])) : _createCommentVNode("", true)]),
            _: 2
          }, 1032, ["loading"])]),
          _: 2
        }, 1032, ["bgColor", "loading"]))]),
        "cell(ltv_offset_18)": _withCtx(row => [!row.item?.kpis?.[_ctx.ltv]?.m18 ? (_openBlock(), _createElementBlock("div", _hoisted_22)) : (_openBlock(), _createBlock(_component_boxed_value, {
          key: 1,
          bgColor: $options.getColorForDecile(row.item?.kpis?.[_ctx.ltv]?.m18, $options.computedMinMax.min, $options.computedMinMax.max, $data.CUSTOMER_INSIGHTS_LTV_COLORS, 5, 4),
          loading: $props.loading
        }, {
          default: _withCtx(() => [_createVNode(_component_hug_value, {
            loading: $props.loading,
            style: {
              "padding": "0px 8px 0px 0px"
            }
          }, {
            default: _withCtx(() => [$data.currency_ltv_options.includes(_ctx.ltv) ? (_openBlock(), _createBlock(_component_currency_value, {
              key: 0,
              value: $options.customerNumberFormat(row.item?.kpis?.[_ctx.ltv]?.m18),
              allowPrecisionModification: false,
              charCount: 5,
              precision: "1"
            }, null, 8, ["value"])) : _createCommentVNode("", true), $data.percentage_ltv_options.includes(_ctx.ltv) ? (_openBlock(), _createBlock(_component_percentage_value, {
              key: 1,
              value: $options.customerNumberFormat(row.item?.kpis?.[_ctx.ltv]?.m18),
              allowPrecisionModification: false,
              charCount: 5,
              precision: "1"
            }, null, 8, ["value"])) : _createCommentVNode("", true), $data.number_ltv_options.includes(_ctx.ltv) ? (_openBlock(), _createBlock(_component_number_value, {
              key: 2,
              value: $options.customerNumberFormat(row.item?.kpis?.[_ctx.ltv]?.m18),
              allowPrecisionModification: false,
              charCount: 5,
              precision: "1",
              tight: ""
            }, null, 8, ["value"])) : _createCommentVNode("", true)]),
            _: 2
          }, 1032, ["loading"])]),
          _: 2
        }, 1032, ["bgColor", "loading"]))]),
        "cell(ltv_offset_19)": _withCtx(row => [!row.item?.kpis?.[_ctx.ltv]?.m19 ? (_openBlock(), _createElementBlock("div", _hoisted_23)) : (_openBlock(), _createBlock(_component_boxed_value, {
          key: 1,
          bgColor: $options.getColorForDecile(row.item?.kpis?.[_ctx.ltv]?.m19, $options.computedMinMax.min, $options.computedMinMax.max, $data.CUSTOMER_INSIGHTS_LTV_COLORS, 5, 4),
          loading: $props.loading
        }, {
          default: _withCtx(() => [_createVNode(_component_hug_value, {
            loading: $props.loading,
            style: {
              "padding": "0px 8px 0px 0px"
            }
          }, {
            default: _withCtx(() => [$data.currency_ltv_options.includes(_ctx.ltv) ? (_openBlock(), _createBlock(_component_currency_value, {
              key: 0,
              value: $options.customerNumberFormat(row.item?.kpis?.[_ctx.ltv]?.m19),
              allowPrecisionModification: false,
              charCount: 5,
              precision: "1"
            }, null, 8, ["value"])) : _createCommentVNode("", true), $data.percentage_ltv_options.includes(_ctx.ltv) ? (_openBlock(), _createBlock(_component_percentage_value, {
              key: 1,
              value: $options.customerNumberFormat(row.item?.kpis?.[_ctx.ltv]?.m19),
              allowPrecisionModification: false,
              charCount: 5,
              precision: "1"
            }, null, 8, ["value"])) : _createCommentVNode("", true), $data.number_ltv_options.includes(_ctx.ltv) ? (_openBlock(), _createBlock(_component_number_value, {
              key: 2,
              value: $options.customerNumberFormat(row.item?.kpis?.[_ctx.ltv]?.m19),
              allowPrecisionModification: false,
              charCount: 5,
              precision: "1",
              tight: ""
            }, null, 8, ["value"])) : _createCommentVNode("", true)]),
            _: 2
          }, 1032, ["loading"])]),
          _: 2
        }, 1032, ["bgColor", "loading"]))]),
        "cell(ltv_offset_20)": _withCtx(row => [!row.item?.kpis?.[_ctx.ltv]?.m20 ? (_openBlock(), _createElementBlock("div", _hoisted_24)) : (_openBlock(), _createBlock(_component_boxed_value, {
          key: 1,
          bgColor: $options.getColorForDecile(row.item?.kpis?.[_ctx.ltv]?.m20, $options.computedMinMax.min, $options.computedMinMax.max, $data.CUSTOMER_INSIGHTS_LTV_COLORS, 5, 4),
          loading: $props.loading
        }, {
          default: _withCtx(() => [_createVNode(_component_hug_value, {
            loading: $props.loading,
            style: {
              "padding": "0px 8px 0px 0px"
            }
          }, {
            default: _withCtx(() => [$data.currency_ltv_options.includes(_ctx.ltv) ? (_openBlock(), _createBlock(_component_currency_value, {
              key: 0,
              value: $options.customerNumberFormat(row.item?.kpis?.[_ctx.ltv]?.m20),
              allowPrecisionModification: false,
              charCount: 5,
              precision: "1"
            }, null, 8, ["value"])) : _createCommentVNode("", true), $data.percentage_ltv_options.includes(_ctx.ltv) ? (_openBlock(), _createBlock(_component_percentage_value, {
              key: 1,
              value: $options.customerNumberFormat(row.item?.kpis?.[_ctx.ltv]?.m20),
              allowPrecisionModification: false,
              charCount: 5,
              precision: "1"
            }, null, 8, ["value"])) : _createCommentVNode("", true), $data.number_ltv_options.includes(_ctx.ltv) ? (_openBlock(), _createBlock(_component_number_value, {
              key: 2,
              value: $options.customerNumberFormat(row.item?.kpis?.[_ctx.ltv]?.m20),
              allowPrecisionModification: false,
              charCount: 5,
              precision: "1",
              tight: ""
            }, null, 8, ["value"])) : _createCommentVNode("", true)]),
            _: 2
          }, 1032, ["loading"])]),
          _: 2
        }, 1032, ["bgColor", "loading"]))]),
        "cell(ltv_offset_21)": _withCtx(row => [!row.item?.kpis?.[_ctx.ltv]?.m21 ? (_openBlock(), _createElementBlock("div", _hoisted_25)) : (_openBlock(), _createBlock(_component_boxed_value, {
          key: 1,
          bgColor: $options.getColorForDecile(row.item?.kpis?.[_ctx.ltv]?.m21, $options.computedMinMax.min, $options.computedMinMax.max, $data.CUSTOMER_INSIGHTS_LTV_COLORS, 5, 4),
          loading: $props.loading
        }, {
          default: _withCtx(() => [_createVNode(_component_hug_value, {
            loading: $props.loading,
            style: {
              "padding": "0px 8px 0px 0px"
            }
          }, {
            default: _withCtx(() => [$data.currency_ltv_options.includes(_ctx.ltv) ? (_openBlock(), _createBlock(_component_currency_value, {
              key: 0,
              value: $options.customerNumberFormat(row.item?.kpis?.[_ctx.ltv]?.m21),
              allowPrecisionModification: false,
              charCount: 5,
              precision: "1"
            }, null, 8, ["value"])) : _createCommentVNode("", true), $data.percentage_ltv_options.includes(_ctx.ltv) ? (_openBlock(), _createBlock(_component_percentage_value, {
              key: 1,
              value: $options.customerNumberFormat(row.item?.kpis?.[_ctx.ltv]?.m21),
              allowPrecisionModification: false,
              charCount: 5,
              precision: "1"
            }, null, 8, ["value"])) : _createCommentVNode("", true), $data.number_ltv_options.includes(_ctx.ltv) ? (_openBlock(), _createBlock(_component_number_value, {
              key: 2,
              value: $options.customerNumberFormat(row.item?.kpis?.[_ctx.ltv]?.m21),
              allowPrecisionModification: false,
              charCount: 5,
              precision: "1",
              tight: ""
            }, null, 8, ["value"])) : _createCommentVNode("", true)]),
            _: 2
          }, 1032, ["loading"])]),
          _: 2
        }, 1032, ["bgColor", "loading"]))]),
        "cell(ltv_offset_22)": _withCtx(row => [!row.item?.kpis?.[_ctx.ltv]?.m22 ? (_openBlock(), _createElementBlock("div", _hoisted_26)) : (_openBlock(), _createBlock(_component_boxed_value, {
          key: 1,
          bgColor: $options.getColorForDecile(row.item?.kpis?.[_ctx.ltv]?.m22, $options.computedMinMax.min, $options.computedMinMax.max, $data.CUSTOMER_INSIGHTS_LTV_COLORS, 5, 4),
          loading: $props.loading
        }, {
          default: _withCtx(() => [_createVNode(_component_hug_value, {
            loading: $props.loading,
            style: {
              "padding": "0px 8px 0px 0px"
            }
          }, {
            default: _withCtx(() => [$data.currency_ltv_options.includes(_ctx.ltv) ? (_openBlock(), _createBlock(_component_currency_value, {
              key: 0,
              value: $options.customerNumberFormat(row.item?.kpis?.[_ctx.ltv]?.m22),
              allowPrecisionModification: false,
              charCount: 5,
              precision: "1"
            }, null, 8, ["value"])) : _createCommentVNode("", true), $data.percentage_ltv_options.includes(_ctx.ltv) ? (_openBlock(), _createBlock(_component_percentage_value, {
              key: 1,
              value: $options.customerNumberFormat(row.item?.kpis?.[_ctx.ltv]?.m22),
              allowPrecisionModification: false,
              charCount: 5,
              precision: "1"
            }, null, 8, ["value"])) : _createCommentVNode("", true), $data.number_ltv_options.includes(_ctx.ltv) ? (_openBlock(), _createBlock(_component_number_value, {
              key: 2,
              value: $options.customerNumberFormat(row.item?.kpis?.[_ctx.ltv]?.m22),
              allowPrecisionModification: false,
              charCount: 5,
              precision: "1",
              tight: ""
            }, null, 8, ["value"])) : _createCommentVNode("", true)]),
            _: 2
          }, 1032, ["loading"])]),
          _: 2
        }, 1032, ["bgColor", "loading"]))]),
        "cell(ltv_offset_23)": _withCtx(row => [!row.item?.kpis?.[_ctx.ltv]?.m23 ? (_openBlock(), _createElementBlock("div", _hoisted_27)) : (_openBlock(), _createBlock(_component_boxed_value, {
          key: 1,
          bgColor: $options.getColorForDecile(row.item?.kpis?.[_ctx.ltv]?.m23, $options.computedMinMax.min, $options.computedMinMax.max, $data.CUSTOMER_INSIGHTS_LTV_COLORS, 5, 4),
          loading: $props.loading
        }, {
          default: _withCtx(() => [_createVNode(_component_hug_value, {
            loading: $props.loading,
            style: {
              "padding": "0px 8px 0px 0px"
            }
          }, {
            default: _withCtx(() => [$data.currency_ltv_options.includes(_ctx.ltv) ? (_openBlock(), _createBlock(_component_currency_value, {
              key: 0,
              value: $options.customerNumberFormat(row.item?.kpis?.[_ctx.ltv]?.m23),
              allowPrecisionModification: false,
              charCount: 5,
              precision: "1"
            }, null, 8, ["value"])) : _createCommentVNode("", true), $data.percentage_ltv_options.includes(_ctx.ltv) ? (_openBlock(), _createBlock(_component_percentage_value, {
              key: 1,
              value: $options.customerNumberFormat(row.item?.kpis?.[_ctx.ltv]?.m23),
              allowPrecisionModification: false,
              charCount: 5,
              precision: "1"
            }, null, 8, ["value"])) : _createCommentVNode("", true), $data.number_ltv_options.includes(_ctx.ltv) ? (_openBlock(), _createBlock(_component_number_value, {
              key: 2,
              value: $options.customerNumberFormat(row.item?.kpis?.[_ctx.ltv]?.m23),
              allowPrecisionModification: false,
              charCount: 5,
              precision: "1",
              tight: ""
            }, null, 8, ["value"])) : _createCommentVNode("", true)]),
            _: 2
          }, 1032, ["loading"])]),
          _: 2
        }, 1032, ["bgColor", "loading"]))]),
        "cell(ltv_offset_24)": _withCtx(row => [!row.item?.kpis?.[_ctx.ltv]?.m24 ? (_openBlock(), _createElementBlock("div", _hoisted_28)) : (_openBlock(), _createBlock(_component_boxed_value, {
          key: 1,
          bgColor: $options.getColorForDecile(row.item?.kpis?.[_ctx.ltv]?.m24, $options.computedMinMax.min, $options.computedMinMax.max, $data.CUSTOMER_INSIGHTS_LTV_COLORS, 5, 4),
          loading: $props.loading
        }, {
          default: _withCtx(() => [_createVNode(_component_hug_value, {
            loading: $props.loading,
            style: {
              "padding": "0px 8px 0px 0px"
            }
          }, {
            default: _withCtx(() => [$data.currency_ltv_options.includes(_ctx.ltv) ? (_openBlock(), _createBlock(_component_currency_value, {
              key: 0,
              value: $options.customerNumberFormat(row.item?.kpis?.[_ctx.ltv]?.m24),
              allowPrecisionModification: false,
              charCount: 5,
              precision: "1"
            }, null, 8, ["value"])) : _createCommentVNode("", true), $data.percentage_ltv_options.includes(_ctx.ltv) ? (_openBlock(), _createBlock(_component_percentage_value, {
              key: 1,
              value: $options.customerNumberFormat(row.item?.kpis?.[_ctx.ltv]?.m24),
              allowPrecisionModification: false,
              charCount: 5,
              precision: "1"
            }, null, 8, ["value"])) : _createCommentVNode("", true), $data.number_ltv_options.includes(_ctx.ltv) ? (_openBlock(), _createBlock(_component_number_value, {
              key: 2,
              value: $options.customerNumberFormat(row.item?.kpis?.[_ctx.ltv]?.m24),
              allowPrecisionModification: false,
              charCount: 5,
              precision: "1",
              tight: ""
            }, null, 8, ["value"])) : _createCommentVNode("", true)]),
            _: 2
          }, 1032, ["loading"])]),
          _: 2
        }, 1032, ["bgColor", "loading"]))]),
        _: 1
      }, 8, ["fields", "items", "tbodyTrClass", "onRowClicked"])]),
      _: 1
    }, 8, ["modelValue", "period"])]),
    _: 3
  }, 8, ["onGoogleSheetDownload", "onCopy", "fields", "loading"]), _createElementVNode("div", _hoisted_29, [_createVNode(_component_b_table, null, {
    "bottom-row": _withCtx(() => [_hoisted_30, _createElementVNode("td", _hoisted_31, [_createVNode(_component_hug_value, {
      loading: $props.loading,
      style: {
        "padding": "0px 8px"
      }
    }, {
      default: _withCtx(() => [_createVNode(_component_slot_with_evolution_value, null, {
        evolution: _withCtx(() => [$options.average?.[$data.evolCategory[_ctx.periodCategory]] ? (_openBlock(), _createBlock(_component_evolution_value, {
          key: 0,
          value: $options.average?.[$data.evolCategory[_ctx.periodCategory]] * 100
        }, {
          default: _withCtx(({
            color
          }) => [_createVNode(_component_percentage_value, {
            value: $options.average?.[$data.evolCategory[_ctx.periodCategory]],
            color: color,
            charCount: 5,
            precision: Math.abs($options.average?.[$data.evolCategory[_ctx.periodCategory]]) >= 0.001 && Math.abs($options.average?.[$data.evolCategory[_ctx.periodCategory]]) <= 0.009 ? 1 : 0,
            showSign: ""
          }, null, 8, ["value", "color", "precision"])]),
          _: 1
        }, 8, ["value"])) : (_openBlock(), _createElementBlock("div", _hoisted_32, "-"))]),
        default: _withCtx(() => [$options.average ? (_openBlock(), _createBlock(_component_value_element, {
          key: 0,
          value: $options.customerNumberFormat($options.average?.customers_in_cohort)
        }, null, 8, ["value"])) : _createCommentVNode("", true)]),
        _: 1
      })]),
      _: 1
    }, 8, ["loading"])]), _createElementVNode("td", _hoisted_33, [_createVNode(_component_hug_value, {
      loading: $props.loading,
      style: {
        "padding": "0px 8px 0px 0px"
      }
    }, {
      default: _withCtx(() => [$data.currency_ltv_options.includes(_ctx.ltv) ? (_openBlock(), _createBlock(_component_currency_value, {
        key: 0,
        value: $options.customerNumberFormat($options.average?.kpis?.[_ctx.ltv]?.m00),
        allowPrecisionModification: false,
        charCount: 5,
        precision: "1"
      }, null, 8, ["value"])) : _createCommentVNode("", true), $data.percentage_ltv_options.includes(_ctx.ltv) ? (_openBlock(), _createBlock(_component_percentage_value, {
        key: 1,
        value: $options.customerNumberFormat($options.average?.kpis?.[_ctx.ltv]?.m00),
        allowPrecisionModification: false,
        charCount: 5,
        precision: "1"
      }, null, 8, ["value"])) : _createCommentVNode("", true), $data.number_ltv_options.includes(_ctx.ltv) ? (_openBlock(), _createBlock(_component_number_value, {
        key: 2,
        value: $options.customerNumberFormat($options.average?.kpis?.[_ctx.ltv]?.m00),
        allowPrecisionModification: false,
        charCount: 5,
        precision: "1",
        tight: ""
      }, null, 8, ["value"])) : _createCommentVNode("", true)]),
      _: 1
    }, 8, ["loading"])]), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.ltvOffset, offset => {
      return _openBlock(), _createElementBlock("td", _hoisted_34, [_createVNode(_component_hug_value, {
        loading: $props.loading,
        style: {
          "padding": "0px 8px 0px 0px"
        }
      }, {
        default: _withCtx(() => [$data.currency_ltv_options.includes(_ctx.ltv) ? (_openBlock(), _createBlock(_component_currency_value, {
          key: 0,
          value: $options.customerNumberFormat($options.average?.kpis?.[_ctx.ltv]?.['m' + offset.split('_')[2]]),
          allowPrecisionModification: false,
          charCount: 5,
          precision: "1"
        }, null, 8, ["value"])) : _createCommentVNode("", true), $data.percentage_ltv_options.includes(_ctx.ltv) ? (_openBlock(), _createBlock(_component_percentage_value, {
          key: 1,
          value: $options.customerNumberFormat($options.average?.kpis?.[_ctx.ltv]?.['m' + offset.split('_')[2]]),
          allowPrecisionModification: false,
          charCount: 5,
          precision: "1"
        }, null, 8, ["value"])) : _createCommentVNode("", true), $data.number_ltv_options.includes(_ctx.ltv) ? (_openBlock(), _createBlock(_component_number_value, {
          key: 2,
          value: $options.customerNumberFormat($options.average?.kpis?.[_ctx.ltv]?.['m' + offset.split('_')[2]]),
          allowPrecisionModification: false,
          charCount: 5,
          precision: "1",
          tight: ""
        }, null, 8, ["value"])) : _createCommentVNode("", true)]),
        _: 2
      }, 1032, ["loading"])]);
    }), 256))]),
    _: 1
  })])], 64);
}